import DragonbonesComponent from '../Component/Dragonbones';
import { dragonBones } from 'dragonbones-pixi';
import PixiArmatureDisplay = dragonBones.PixiArmatureDisplay;
import PIXIRenderer from '../System/Render/PIXIRenderer';
import Game from '../Game';
import AnimationComponent from '../Component/Animation';
import TransformComponent from '../Component/Transform';
import GameObject from '../GameObject/GameObject';
import Renderable from '../Component/Renderable';

export default class Armature extends GameObject<PixiArmatureDisplay> {
    public container: PixiArmatureDisplay;

    protected instantiateContainer(params: any): void {
        if (
            !PIXIRenderer.dbFactory.getAllDragonBonesData()[
                params.dragonbonesName
            ]
        ) {
            PIXIRenderer.dbFactory.parseDragonBonesData(
                Game.resource.get<any>(
                    params.dragonbonesName + '_skeleton_data'
                )
            );
            PIXIRenderer.dbFactory.parseTextureAtlasData(
                Game.resource.get<any>(
                    params.dragonbonesName + '_texture_data'
                ),
                Game.resource.get<any>(params.dragonbonesName + '_texture')
            );
        }

        this.container = PIXIRenderer.dbFactory.buildArmatureDisplay(
            params.armatureName,
            params.dragonbonesName
        );

        this.container.visible = false;
        //this.container.armature.clock = null;
    }

    protected onCreate(params: any): void {
        this.addComponent(Renderable, params);
        this.addComponent(TransformComponent, params);
        this.addComponent(DragonbonesComponent, params);
        this.addComponent(AnimationComponent, params);
    }
}
